import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import { Trans } from 'react-i18next';
import { all, put, call, take, takeEvery, race, select } from 'redux-saga/effects';
import { URLS, Url } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { Warning as WarningIllustration } from '@wix/da-ds/pkg/Icons/Confirmations';
import { editDeviation } from '../../../redux/deviations/actionCreators';
import { requestPuppy, isApiError } from '@wix/da-http-client/pkg/request';
import { logBiEvent } from '../../../biLogger/redux/saga';
import { DeviationResourceType } from '../../../types/deviation';
import { reduxModuleLoaded, saveTierAsDraft, saveTierAsDraftAndBuyCore, publishTier, deleteTier, updateTier, tierSaveError, tierSaveRedirect, tierSaveRedirectAfterDraft, publishDraftTier } from './actions';
import { pushGlobalConfirmationModal, confirmNo, confirmYes, popModal } from '../../../Modals/redux/actionCreators';
import { getCurrentUser, getCurrentUserHasCore } from '../../../publicSession/selectors';
import i18next from 'i18next';
import { putErrorNotification } from '../../../utils/saga';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './tierPopupSaga.scss';
const logger = ddt.createLogger('tierpopup');
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        logger.log('faking the response!');
        const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        return _object_spread({}, deviationsByType.tiers[0], (options === null || options === void 0 ? void 0 : options.data) || {});
    }
}
function handleSaveTier({ title, description, price, benefits, tags, accessSettings, matureContent, coverImage, showSubscriberCount = false, messageTitle, messageText, tierId = undefined, discordRoles }) {
    const isUpdate = !!tierId;
    const url = isUpdate ? '/tier/update' : '/tier/create';
    const method = 'post';
    const isMature = matureContent !== undefined && matureContent !== 'safe';
    let data = {
        title,
        description,
        price: parseInt(price || '1'),
        display_num_subscribers: showSubscriberCount,
        benefits,
        tags,
        access_settings: accessSettings,
        thank_message_title: messageTitle,
        thank_message_body: messageText,
        cover_image_deviation_id: coverImage === null || coverImage === void 0 ? void 0 : coverImage.deviationId,
        is_mature: isMature,
        mature_level: isMature ? matureContent : undefined,
        discord_role_ids: discordRoles
    };
    if (isUpdate) {
        data = _object_spread_props(_object_spread({}, data), {
            tierid: tierId
        });
    }
    return call(requestPuppy, {
        method,
        url,
        data
    }, fakeResponse);
}
function getCommonBiDataFromPayload(actionPayload) {
    const { deviationId, showSubscriberCount, accessSettings } = actionPayload;
    return {
        itemid: deviationId,
        typeid: deviationId ? DeviationResourceType.TIER : undefined,
        display_subscribers: showSubscriberCount ? 1 : 0,
        access_settings: accessSettings
    };
}
function* publishTierSaga(action) {
    var _createOrUpdateResponse_deviation_tier, _createOrUpdateResponse_deviation;
    yield call(logBiEvent, BiData(_object_spread({
        evid: 535
    }, getCommonBiDataFromPayload(action.payload))));
    let { tierId } = action.payload;
    logger.log('payload', action.payload);
    // Create OR update the tier
    const createOrUpdateResponse = yield handleSaveTier(action.payload);
    if (!createOrUpdateResponse) {
        yield putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'));
        yield put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')));
        return;
    }
    if (isApiError(createOrUpdateResponse)) {
        yield putErrorNotification(createOrUpdateResponse.errorDescription);
        yield put(tierSaveError(createOrUpdateResponse.errorDescription));
        return;
    }
    if (!(createOrUpdateResponse === null || createOrUpdateResponse === void 0 ? void 0 : (_createOrUpdateResponse_deviation = createOrUpdateResponse.deviation) === null || _createOrUpdateResponse_deviation === void 0 ? void 0 : (_createOrUpdateResponse_deviation_tier = _createOrUpdateResponse_deviation.tier) === null || _createOrUpdateResponse_deviation_tier === void 0 ? void 0 : _createOrUpdateResponse_deviation_tier.tierId)) {
        yield putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'));
        yield put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')));
        return;
    }
    tierId = createOrUpdateResponse.deviation.tier.tierId;
    // Publish the tier
    const data = {
        tierid: tierId
    };
    const response = yield call(requestPuppy, {
        method: 'post',
        url: '/tier/publish',
        data
    });
    if (!response) {
        yield putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'));
        yield put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')));
        return;
    }
    if (isApiError(response)) {
        yield putErrorNotification(response.errorDescription);
        yield put(tierSaveError(response.errorDescription));
        return;
    }
    yield put(tierSaveRedirect());
    window.location.reload();
    const currentUser = yield select(getCurrentUser);
    window.location.href = `${Url.userSubscriptionsPath({
        username: currentUser.username,
        tierDeviationId: tierId
    })}?tier-publish-success=1`;
}
function* publishDraftTierSaga(action) {
    var _response_deviation;
    yield call(logBiEvent, BiData(_object_spread({
        evid: 535
    }, getCommonBiDataFromPayload(action.payload))));
    const deviation = action.payload;
    const { deviationId } = deviation;
    const data = {
        tierid: deviationId
    };
    const response = yield call(requestPuppy, {
        method: 'post',
        url: '/tier/publish',
        data
    });
    if (!response || isApiError(response)) {
        yield put(editDeviation({
            deviation
        }));
        return;
    }
    yield put(tierSaveRedirect());
    const currentUser = yield select(getCurrentUser);
    window.location.href = `${Url.userSubscriptionsPath({
        username: currentUser.username,
        tierDeviationId: response === null || response === void 0 ? void 0 : (_response_deviation = response.deviation) === null || _response_deviation === void 0 ? void 0 : _response_deviation.deviationId
    })}?tier-publish-success=1`;
}
function* updateTierSaga(action) {
    yield call(logBiEvent, BiData(_object_spread({
        evid: 538
    }, getCommonBiDataFromPayload(action.payload))));
    const response = yield handleSaveTier(action.payload);
    if (!response) {
        yield putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'));
        yield put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')));
        return;
    }
    if (isApiError(response)) {
        yield putErrorNotification(response.errorDetails || response.errorDescription);
        yield put(tierSaveError(response.errorDescription));
        return;
    }
    yield put(tierSaveRedirect());
    window.location.reload();
}
function* saveTierDraftSaga(action) {
    const { deviationId } = action.payload;
    const currentUserHasCore = yield select(getCurrentUserHasCore);
    yield call(logBiEvent, BiData(_object_spread({
        evid: 539
    }, getCommonBiDataFromPayload(action.payload))));
    if (action.type === saveTierAsDraft.toString()) {
        yield put(pushGlobalConfirmationModal({
            titleTransKey: 'tierPopup.saveConfirmation.title',
            textTransKey: currentUserHasCore ? 'tierPopup.saveConfirmation.text' : 'tierPopup.saveConfirmation.text.nonCore',
            cancelBtnLabelTransKey: 'tierPopup.saveConfirmation.button.cancel',
            confirmBtnLabelTransKey: 'tierPopup.saveConfirmation.button.confirm',
            confirmBtnBiData: BiData({
                evid: 540,
                typeid: deviationId ? DeviationResourceType.TIER : 0,
                itemid: deviationId !== null && deviationId !== void 0 ? deviationId : 0,
                display_subscribers: action.payload.showSubscriberCount ? 1 : 0,
                access_settings: action.payload.accessSettings
            }),
            icon: /*#__PURE__*/ React.createElement(WarningIllustration, null),
            closeOnConfirmation: false
        }));
        const { no } = yield race({
            yes: take(confirmYes),
            no: take(confirmNo)
        });
        if (no) {
            yield put(popModal());
            return;
        }
    }
    logger.log('saving', action.payload);
    const response = yield handleSaveTier(action.payload);
    if (!response) {
        yield putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'));
        yield put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')));
        return;
    }
    if (isApiError(response)) {
        yield putErrorNotification(response.errorDescription);
        yield put(tierSaveError(response.errorDescription));
        return;
    }
    if (action.type === saveTierAsDraft.toString()) {
        yield put(tierSaveRedirectAfterDraft());
        const currentUser = yield select(getCurrentUser);
        requestAnimationFrame(()=>{
            window.location.href = Url.userSubscriptionsPath({
                username: currentUser.username
            });
        });
    } else if (action.type === saveTierAsDraftAndBuyCore.toString()) {
        yield put(tierSaveRedirectAfterDraft());
        requestAnimationFrame(()=>{
            window.location.href = URLS.CORE_MEMBERSHIP;
        });
    }
}
function* deleteTierSaga(action) {
    var _action_payload_deviation_tier, _action_payload_deviation, _action_payload, _action_payload_deviation_tier_stats, _action_payload_deviation_tier1, _action_payload_deviation_tier2;
    const tierid = action === null || action === void 0 ? void 0 : (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : (_action_payload_deviation = _action_payload.deviation) === null || _action_payload_deviation === void 0 ? void 0 : (_action_payload_deviation_tier = _action_payload_deviation.tier) === null || _action_payload_deviation_tier === void 0 ? void 0 : _action_payload_deviation_tier.tierId;
    if (!tierid) {
        yield putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'));
        yield put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')));
        return;
    }
    var _action_payload_deviation_tier_stats_subscribers;
    const hasSubscribers = ((_action_payload_deviation_tier_stats_subscribers = (_action_payload_deviation_tier1 = action.payload.deviation.tier) === null || _action_payload_deviation_tier1 === void 0 ? void 0 : (_action_payload_deviation_tier_stats = _action_payload_deviation_tier1.stats) === null || _action_payload_deviation_tier_stats === void 0 ? void 0 : _action_payload_deviation_tier_stats.subscribers) !== null && _action_payload_deviation_tier_stats_subscribers !== void 0 ? _action_payload_deviation_tier_stats_subscribers : 0) > 0;
    const isDraft = ((_action_payload_deviation_tier2 = action.payload.deviation.tier) === null || _action_payload_deviation_tier2 === void 0 ? void 0 : _action_payload_deviation_tier2.state) === 'draft';
    const textTranslationKey = isDraft ? 'tierPopup.deleteConfirmation.draft.text' : hasSubscribers ? 'tierPopup.deleteConfirmation.published.hasSubscribers.text' : 'tierPopup.deleteConfirmation.published.noSubscribers.text';
    const textTranslationCmp = ()=>/*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: textTranslationKey
        }, "New subscribers won’t be able to join. Content not associated with a different tier will become visible to all.", /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
            href: "https://www.deviantartsupport.com/en/article/how-do-i-edit-or-delete-a-tier",
            target: "_blank",
            className: s['modal-link']
        }, "Learn more about deleting tiers")));
    yield put(pushGlobalConfirmationModal({
        titleTransKey: isDraft ? 'tierPopup.deleteConfirmation.draft.title' : 'tierPopup.deleteConfirmation.published.title',
        textComponent: textTranslationCmp,
        cancelBtnLabelTransKey: 'tierPopup.deleteConfirmation.button.cancel',
        confirmBtnLabelTransKey: 'tierPopup.deleteConfirmation.button.confirm',
        confirmBtnBiData: BiData({
            evid: 541,
            typeid: DeviationResourceType.TIER,
            itemid: action.payload.deviation.deviationId,
            has_subscribers: hasSubscribers ? 1 : 0
        }),
        icon: /*#__PURE__*/ React.createElement(WarningIllustration, null),
        closeOnConfirmation: false
    }));
    const { no } = yield race({
        yes: take(confirmYes),
        no: take(confirmNo)
    });
    if (no) {
        yield put(popModal());
        return;
    }
    logger.log('deleting', tierid);
    const data = {
        tierid
    };
    const response = yield call(requestPuppy, {
        method: 'post',
        url: `/tier/delete`,
        data
    }, fakeResponse);
    if (!response) {
        yield putErrorNotification(i18next.t('tierPopup.error.writeTierServerError'));
        yield put(tierSaveError(i18next.t('tierPopup.error.writeTierServerError')));
        return;
    }
    if (isApiError(response)) {
        yield putErrorNotification(response.errorDescription);
        yield put(tierSaveError(response.errorDescription));
        return;
    }
    yield put(tierSaveRedirect());
    const currentUser = yield select(getCurrentUser);
    window.location.href = Url.userSubscriptionsPath({
        username: currentUser.username
    });
}
export default function* saga() {
    yield take(reduxModuleLoaded); // wait for redux to load
    yield all([
        takeEvery(saveTierAsDraft, saveTierDraftSaga),
        takeEvery(saveTierAsDraftAndBuyCore, saveTierDraftSaga),
        takeEvery(publishTier, publishTierSaga),
        takeEvery(publishDraftTier, publishDraftTierSaga),
        takeEvery(deleteTier, deleteTierSaga),
        takeEvery(updateTier, updateTierSaga)
    ]);
}

//# sourceMappingURL=tierPopupSaga.js.map